import createIcon from '../../createIcon';

/**
 * @component @name ControlPointDuplicate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgOEgxNFYxMUgxMVYxM0gxNFYxNkgxNlYxM0gxOVYxMUgxNlY4Wk0yIDEyQzIgOS4yMSAzLjY0IDYuOCA2LjAxIDUuNjhWMy41MkMyLjUyIDQuNzYgMCA4LjA5IDAgMTJDMCAxNS45MSAyLjUyIDE5LjI0IDYuMDEgMjAuNDhWMTguMzJDMy42NCAxNy4yIDIgMTQuNzkgMiAxMlpNMTUgM0MxMC4wNCAzIDYgNy4wNCA2IDEyQzYgMTYuOTYgMTAuMDQgMjEgMTUgMjFDMTkuOTYgMjEgMjQgMTYuOTYgMjQgMTJDMjQgNy4wNCAxOS45NiAzIDE1IDNaTTE1IDE5QzExLjE0IDE5IDggMTUuODYgOCAxMkM4IDguMTQgMTEuMTQgNSAxNSA1QzE4Ljg2IDUgMjIgOC4xNCAyMiAxMkMyMiAxNS44NiAxOC44NiAxOSAxNSAxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ControlPointDuplicate = createIcon('ControlPointDuplicate', [
  [
    'path',
    {
      d: 'M16 8H14V11H11V13H14V16H16V13H19V11H16V8ZM2 12C2 9.21 3.64 6.8 6.01 5.68V3.52C2.52 4.76 0 8.09 0 12C0 15.91 2.52 19.24 6.01 20.48V18.32C3.64 17.2 2 14.79 2 12ZM15 3C10.04 3 6 7.04 6 12C6 16.96 10.04 21 15 21C19.96 21 24 16.96 24 12C24 7.04 19.96 3 15 3ZM15 19C11.14 19 8 15.86 8 12C8 8.14 11.14 5 15 5C18.86 5 22 8.14 22 12C22 15.86 18.86 19 15 19Z',
      key: '1wa4wx',
    },
  ],
]);

export default ControlPointDuplicate;
